// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "10edf77253d3cd6f24f29ab3a3b49489" + ".js";
};